import AbstractVideo from "video/AbstractVideo";
import VideoHelper from "video/VideoHelper";

class YoutubeVideo extends AbstractVideo {

    constructor(data, $element, settings = {}) {
        super(data, $element, settings);

        this.initialisePlayer();
    }

    play() {
        this.player.playVideo();
    }

    pause() {
        this.player.pauseVideo();
    }

    stop() {
        this.player.stopVideo();
    }

    seek(time) {
        this.player.seekTo(time, true);
    }

    setVolume(volume) {
        this.player.setVolume(volume * 100);

    }

    initialisePlayer() {
        if($('#' + this.element_id).length === 0) throw new Error('The video element must be on the page before initialising the player');
        this.player = new YT.Player(this.element_id, {
            videoId: this.video_id,
            playerVars: {
                modestbranding: true,
                showinfo: false,
                rel: 0,
                autoplay: this.settings.autoplay ? 1 : 0,
                autohide: 1
            },
            events: {
                'onReady': (event) => {
                    this.emit("loaded")
                },
                'onStateChange': (event) => {
                    if (event.data === YT.PlayerState.ENDED) {
                        this.emit("ended");
                    } else if (event.data === YT.PlayerState.PLAYING) {
                        this.emit("play");
                    } else if (event.data === YT.PlayerState.PAUSED) {
                        this.emit("pause");
                    }
                }
            }
        });
    }

    destroy() {
        super.destroy();

        this.player.destroy();
        this.player = null;
    }
}

VideoHelper.register('1' /*Vimeo*/, YoutubeVideo);

export default YoutubeVideo;
